import { createAsyncThunk } from "@reduxjs/toolkit";
import { userService } from "../../../services/user.service";

export const fetchUserProfile = createAsyncThunk("user/fetchUserProfile", async (_, thunkAPI) => {
  const response = await userService.getProfile();
  return response.data;
});
